import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/digithia-logo.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-9583a880")

_pushScopeId("data-v-9583a880")
const _hoisted_1 = { class: "ask-reset-password" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  slot: "logo",
  src: _imports_0,
  class: "logo"
}, null, -1)
const _hoisted_3 = {
  slot: "title",
  class: "center title-2"
}
const _hoisted_4 = {
  slot: "form",
  class: "ask-password-form"
}
const _hoisted_5 = { class: "info-text" }
const _hoisted_6 = {
  slot: "links",
  class: "link"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("dig-ui-login-card", _hoisted_1, [
    _hoisted_2,
    _createVNode("dig-ui-title", _hoisted_3, _toDisplayString(_ctx.$t('askResetPassword')), 1),
    _createVNode("div", _hoisted_4, [
      _createVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('askResetPasswordMessage')), 1),
      _createVNode("dig-input-text", {
        value: $setup.username,
        onInput: _cache[1] || (_cache[1] = ($event: any) => ($setup.username = $event.target.value)),
        onKeyup: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.keydownAsk && $setup.keydownAsk(...args))),
        id: "username",
        required: ""
      }, _toDisplayString(_ctx.$t('usernameOrEmail')), 41, ["value"]),
      _createVNode("div", null, [
        _createVNode("dig-ui-standard-button", {
          disabled: $setup.loading,
          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.askResetPassword()))
        }, _toDisplayString(_ctx.$t('validate')), 9, ["disabled"])
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode(_component_router_link, { to: "/login" }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('login')), 1)
        ]),
        _: 1
      })
    ])
  ]))
})